import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AlertController, LoadingController} from '@ionic/angular';
import {Router} from '@angular/router';
import {AlertService} from '../../services/alert.service';
import {BidService} from '../../services/bid.service';
import {StorageService} from '../../services/storage.service';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.page.html',
  styleUrls: ['./otp.page.scss'],
})
export class OtpPage implements OnInit {


  orderId;
  otpIn1;
  otpIn2;
  otpIn3;
  otpIn4;
  otpIn5;
  otpIn6;
  operationId;

  @ViewChild('otp1') searchElementOtp1: ElementRef;
  @ViewChild('otp2') searchElementOtp2: ElementRef;
  @ViewChild('otp3') searchElementOtp3: ElementRef;
  @ViewChild('otp4') searchElementOtp4: ElementRef;
  @ViewChild('otp5') searchElementOtp5: ElementRef;
  @ViewChild('otp6') searchElementOtp6: ElementRef;

  constructor(public alertController: AlertController, private router: Router,
              private loadingController: LoadingController,
              private bidService: BidService,
              private alertService: AlertService,
              private storageService: StorageService) {

    this.storageService.getStorage('orderId').then(data => {
      this.orderId = data.value;
    });
  }

  ngOnInit() {
    this.getValuesStorge().then();
  }

  async getValuesStorge() {

    this.operationId = await this.storageService.getStorageSync('operationIdOTP');
    console.log(this.operationId);
  }

  async validateOTP() {
    if (!this.getOtpFromView() || this.getOtpFromView().length < 6) {
      this.showNoValidOTP();
      return
    }

    console.log(this.searchElementOtp1.nativeElement.value);

    this.loadingController.getTop().then(hasLoading => {
      this.loadingController.create({
        spinner: 'circular',
        translucent: true
      }).then(loading => loading.present());
    });

    const req = {
      operationId: this.operationId,
    };

    this.bidService.confirmOrder(
      this.orderId,
      this.getOtpFromView(), 
      req
    ).subscribe(async (data: any) => {

      if (!data.active) {
        const alert = await this.alertController.create({
          mode: 'ios',
          message: 'Su contrato  fue firmado con exito.',
          buttons: [
            {
              text: 'Aceptar',
              handler: () => {
                this.nextPage();
              }
            }
          ]
        });

        await alert.present();
      } else {
        this.storageService.removeValueInStorage('orderId');
        this.showNoValidOTP();
      }
      this.loadingController.dismiss().then();


    }, (data: any) => {
      this.loadingController.dismiss();
      if(data.error.error && data.error.error.code === "opt-used") {
        this.alertService.presentAlert('Error', 'OTP ya usado o expirado').then();
      } else {
        this.showNoValidOTP();
      }
      this.storageService.removeValueInStorage('orderId');
    });


  }

  getOtpFromView() {
    return `${this.searchElementOtp1.nativeElement.value}${this.searchElementOtp2.nativeElement.value}${this.searchElementOtp3.nativeElement.value}${this.searchElementOtp4.nativeElement.value}${this.searchElementOtp5.nativeElement.value}${this.searchElementOtp6.nativeElement.value}`
  }

  showNoValidOTP() {
    this.alertService.presentAlert('Error', 'OTP invalido').then();
  }

  nextPage() {


    this.storageService.removeValueInStorage('orderId');
    this.router.navigateByUrl('bandeja-contratos');

  }


  modelChangeFn(value, id) {
    switch (id) {
      case 'otp1':
        this.searchElementOtp2.nativeElement.focus();
        break;
      case 'otp2':
        this.searchElementOtp3.nativeElement.focus();
        break;
      case 'otp3':
        this.searchElementOtp4.nativeElement.focus();
        break;
      case 'otp4':
        this.searchElementOtp5.nativeElement.focus();
        break;
      case 'otp5':
        this.searchElementOtp6.nativeElement.focus();
        break;
      case 'otp6':
        this.searchElementOtp1.nativeElement.focus();
        break;
    }

  }

  refresh() {
    this.validateOTP();
  }
}
